import { useCallback, useState } from "react";

export enum UsersViewMode {
  List = "list",
  Cards = "cards",
}

const STORAGE_KEY = "gestao_perfis.users_view_mode";

function readStored(): UsersViewMode {
  if (typeof window === "undefined") return UsersViewMode.List;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === UsersViewMode.Cards ? UsersViewMode.Cards : UsersViewMode.List;
}

export function useUsersViewMode() {
  const [mode, setModeState] = useState<UsersViewMode>(readStored);

  const setMode = useCallback((next: UsersViewMode) => {
    window.localStorage.setItem(STORAGE_KEY, next);
    setModeState(next);
  }, []);

  return { mode, setMode };
}
